import { create } from 'zustand';
import { produce } from 'immer';
export const initialState = {
    labels: [],
};
export const useLabelsStore = create((set, get) => ({
    ...initialState,
    setLabels: (labels) => set({ labels }),
    addLabel: (label) => set(produce((state) => {
        state.labels.push(label);
        state.labels.sort((a, b) => a.value.localeCompare(b.value));
    })),
    removeLabel: (labelId) => set(produce((state) => {
        const idx = state.labels.findIndex((x) => x.id === labelId);
        if (idx !== -1) {
            state.labels.splice(idx, 1);
        }
    })),
    updateLabel: (label) => set(produce((state) => {
        const idx = state.labels.findIndex((x) => x.id === label.id);
        if (idx !== -1) {
            state.labels[idx] = label;
        }
    })),
    reset: () => set(initialState),
}));
export const selectLabelById = (state, labelId) => state.labels.find((label) => label.id === labelId);
